// demo-state.js — pure helpers shared by the demo engine bridge, the fallback
// loop, and the render consumers. NO DOM / browser globals here (keeps it
// unit-testable under `node --test`).

export function letterFor(n) {
  return n <= 15 ? 'B' : n <= 30 ? 'I' : n <= 45 ? 'N' : n <= 60 ? 'G' : 'O';
}

// The old autoplay.js sequence — now the offline fallback only.
export var FALLBACK_SEQUENCE = [
  3, 11, 17, 24, 31, 37, 49, 51, 54, 67, 71, 4, 13, 29, 38,
  7, 22, 45, 63, 8, 26, 42, 58, 74, 12, 19, 28, 33, 56, 65,
];

// Deepest history any strip needs (the caller strip shows 10 + 1 overflow chip it
// animates out). Each strip slices this down to its own data-bingo-history-max.
export var HISTORY_DEPTH = 12;

function historyFrom(calledNumbers) {
  // All-but-last (the current call shows separately), most recent first, capped.
  var all = calledNumbers.slice(0, Math.max(0, calledNumbers.length - 1));
  return all.slice(-HISTORY_DEPTH).reverse();
}

// Map a DauberDemo engine state to the (extended) `bingocall` event detail.
export function mapDemoState(demo) {
  if (!demo || !demo.enabled) {
    return {
      phase: 'off', called: [], current: null, currentLetter: null,
      history: [], callNumber: 0, total: 75, pattern: null, nextRoundInMs: 0,
    };
  }
  var called = demo.calledNumbers || [];
  var current = demo.lastNumber != null ? demo.lastNumber : null;
  return {
    phase: demo.phase === 'intermission' ? 'intermission' : 'calling',
    called: called,
    current: current,
    currentLetter: current != null ? letterFor(current) : null,
    history: historyFrom(called),
    callNumber: demo.callIndex || 0,
    total: 75,
    pattern: demo.pattern || null,
    nextRoundInMs: demo.nextRoundInMs || 0,
  };
}

// A cheap signature so we only touch the DOM when something visible changes.
export function stateSignature(s) {
  if (!s || s.phase === 'off') return 'off';
  if (s.phase === 'intermission') {
    return 'i:' + s.roundId + ':' + Math.ceil((s.nextRoundInMs || 0) / 1000);
  }
  return 'c:' + s.roundId + ':' + s.callNumber;
}

// Fallback render state for a given index into FALLBACK_SEQUENCE.
export function buildFallbackState(idx) {
  var current = FALLBACK_SEQUENCE[idx];
  var called = FALLBACK_SEQUENCE.slice(0, idx + 1);
  return {
    phase: 'calling',
    called: called,
    current: current,
    currentLetter: letterFor(current),
    history: historyFrom(called),
    // 1-based, matching mapDemoState's callIndex field.
    callNumber: idx + 1,
    total: 75,
    pattern: null,
    nextRoundInMs: 0,
  };
}
